<template>
  <form>
    <ModalEdition :isEdition="params.id != null" :modalId="'modalEditCommande'" ref="modalCommandeRef"
      :dialogClass="'modal-dialog modal-lg'" @save="saveCommande">
      <div class="form">

        <div class="row align-items-center mb-3">
          <div class="col-md-5 d-flex align-items-center">
            <label for="commande_longueur_bois" class="mb-0">Longueur des bûches: <span v-if="!commande.longueurBois"
                class="text-danger">*</span></label>
          </div>
          <div class="col-md-4">

            <div class="input-group">
              <input type="number" list="longueurs" v-model="commande.longueurBois" class="form-control" required />
              <span class="input-group-text">cm</span>
            </div>

            <datalist id="longueurs">
              <option value="33"></option>
              <option value="40"></option>
              <option value="50"></option>
            </datalist>
          </div>
        </div>

        <div class="row align-items-end mb-1">
          <div class="col-md-4">
            <div class="form-group">
              <label for="commande_quantite_bois">Nombre de stère:<span v-if="!commande.quantiteBois"
                  class="text-danger">*</span></label>
              <input type="number" class="form-control" id="commande_quantite_bois"
                v-model.number="commande.quantiteBois" min="0" step="0.1">
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="commande_prix_unitaire_bois">Prix unitaire:<span v-if="!commande.prixUnitaireBois"
                  class="text-danger">*</span></label>
              <div class="input-group">
                <input type="number" class="form-control" id="commande_prix_unitaire_bois"
                  v-model.number="commande.prixUnitaireBois" step="5" min="0">
                <span class="input-group-text">€</span>
              </div>
            </div>
          </div>

          <div class="col-md-4 text-center">
            <div class="form-group">
              <label>Total : </label>
              {{ (commande.quantiteBois * commande.prixUnitaireBois || 0).toFixed(2) }} €
            </div>
          </div>
        </div>


        <div class="row align-items-end mb-1">
          <div class="col-md-4">
            <div class="form-group">
              <label for="commande_quantite_sac">Nombre de sac:<span v-if="!commande.quantiteSac"
                  class="text-danger">*</span></label>
              <input type="number" class="form-control" id="commande_quantite_sac" v-model.number="commande.quantiteSac"
                min="0">
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="commande_prix_unitaire_sac">Prix unitaire:<span v-if="!commande.prixUnitaireSac"
                  class="text-danger">*</span></label>
              <div class="input-group">
                <input type="number" class="form-control" id="commande_prix_unitaire_sac"
                  v-model.number="commande.prixUnitaireSac" step="1" min="0">
                <span class="input-group-text">€</span>
              </div>
            </div>
          </div>

          <div class="col-md-4 text-center">
            <div class="form-group">
              <label>Total :</label>
              {{ (commande.quantiteSac * commande.prixUnitaireSac || 0).toFixed(2) }} €
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-2 d-flex align-items-center">
            <label for="commande_livraison" class="mb-0">Livraison:<span v-if="!commande.fraisLivraison.id"
                class="text-danger">*</span></label>
          </div>
          <div class="col-md-5">
            <select v-model="commande.fraisLivraison.id" class="form-select" id="commande_frais_livraison">
              <option v-for="liv in fraisLivraison" :value="liv.id" :key="liv.id">
                {{ liv.distance }} - {{ liv.prix }}€
              </option>
            </select>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-4 d-flex align-items-center">
            <label for="commande_tranche_horaire" class="mb-0">Horaire de livraison:</label>
          </div>
          <div class="col-md-5">
            <select class="form-control" v-model="commande.trancheHoraire" id="commande_tranche_horaire">
              <option disabled value="">-- Sélectionnez un horaire --</option>
              <option value="10h - 12h">10h - 12h</option>
              <option value="11h - 13h">11h - 13h</option>
              <option value="12h - 14h">12h - 14h</option>
              <option value="14h - 16h">14h - 16h</option>
              <option value="15h - 17h">15h - 17h</option>
              <option value="16h - 18h">16h - 18h</option>
            </select>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-4 d-flex align-items-center">
            <label for="commande_type_paiement" class="mb-0">Type de paiement:</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" id="commande_type_paiement" v-model="commande.typePaiement">
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-4 d-flex align-items-center">
            <label for="commande_num_facture" class="mb-0">Numéro de facture:</label>
          </div>
          <div class="col-md-5">
            <input type="text" class="form-control" id="commande_num_facture" v-model="commande.numFacture">
          </div>
        </div>

        <div class="form-group">
          <label for="commande_notes">Notes:</label>
          <textarea id="commande_notes" class="form-control" v-model="commande.notes"></textarea>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-2 d-flex align-items-center">
            <label for="commande_quantite_bois">Réduction:</label>
          </div>
          <div class="col-md-5">
            <div class="input-group">
              <input type="number" class="form-control" id="commande_reduction" v-model="commande.reduction" min="0">
              <span class="input-group-text">€</span>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-md-12 text-center">
            <div class="border bg-light" style="border-radius: 10px;">
              <label>Total de la commande:</label>
              {{ totalCommande }} €

            </div>
          </div>
        </div>
      </div>
    </ModalEdition>
  </form>
</template>

<script>
import Axios from '@/services/axios.service';
import ModalEdition from '../../../../components/ModalEdition.vue';

export default {
  name: 'CommandeEdit',
  components: {
    ModalEdition
  },
  props: {
    params: {
      type: Object,
      required: false,
      default: () => ({}),
    },

  },
  data() {
    return {
      commande: {
        fraisLivraison: {},
        identite: {},
        prixUnitaireBois: 95,
        prixUnitaireSac: 8,
      },
      fraisLivraison: [],
      errors: [],
    }
  },
  mounted() {
    this.getFraisLivraison();
  },
  methods: {
    getCommande(id) {
      Axios.get('/commande/' + id).then(res => {
        this.commande = res.data;
      }).catch(err => {
        console.error('Erreur lors du chargement de la commande :', err);
      });
    },
    getFraisLivraison() {
      Axios.get('/fraisLivraison').then(res => {
        this.fraisLivraison = res.data;
      }).catch(err => {
        console.error('Erreur lors du chargement des fraisLivraison :', err);
      });
    },
    saveCommande() {
      this.errors = [];
      if (this.errors.length) {
        this.$refs.modalCommandeRef.errorMessage(this.errors)
        return;
      }

      if (this.commande.dateCreation == null) {
        this.commande.dateCreation = new Date();
      }

      if (this.commande.quantiteSac == null) {
        this.commande.quantiteSac = 0;
      }

      if (this.commande.reduction == null) {
        this.commande.reduction = 0;
      }

      Axios.post('/commande', this.commande)
        .then(() => {
          this.$refs.modalCommandeRef.closeModal();
          this.$emit('saved');
        }).catch(err => {
          console.error('Erreur lors de la sauvegarde de la commande:', err);
        });
    },
  },
  computed: {
    PrixlivraisonSelectionnee() {
      const liv = this.fraisLivraison.find(liv => liv.id === this.commande.fraisLivraison.id);
      return { prix: Number(liv?.prix || 0) };
    },
    totalCommande() {
      return (
        (this.commande.quantiteSac * this.commande.prixUnitaireSac || 0) +
        (this.commande.quantiteBois * this.commande.prixUnitaireBois || 0) +
        (this.PrixlivraisonSelectionnee.prix || 0) -
        (this.commande.reduction || 0)
      ).toFixed(2);
    }
  },
  watch: {
    params: {
      handler(params) {

        if (params.id != null) {
          this.getCommande(params.id);
        } else {
          this.commande.fraisLivraison = {};
          this.commande.identite.id = params.idIdentite
        }
      },
      deep: true,
    }
  },
}
</script>

<style>
.form {
  max-width: 550px;
  margin: 0 auto;
}

.formGroup {
  max-width: 550px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
</style>